import config from '../config';

/**
 * App Version Utilities
 */
export class AppVersion {
  static get version(): string {
    return config.app.version;
  }

  static get appName(): string {
    return config.app.name;
  }

  static get environment(): string {
    return config.app.environment;
  }

  static get fullVersion(): string {
    return `${this.appName} v${this.version}`;
  }

  static get isDevelopment(): boolean {
    return this.environment === 'development';
  }

  static get isProduction(): boolean {
    return this.environment === 'production';
  }

  static get buildInfo(): string {
    return `${this.version} (${this.environment})`;
  }

  static logVersion(): void {
    console.log(`🚀 ${this.fullVersion}`);
    console.log(`📦 Environment: ${this.environment}`);
    console.log(`🏗️  Build: ${this.buildInfo}`);
  }
}

// Export für einfache Verwendung
export const { version, appName, environment, fullVersion } = AppVersion;